import { createContext } from "react";
import { Tenant } from "../../types";

export const TENANT_IDS = {
  ATTRACTION: "attraction",
  JAMEO: "jameo",
} as const;

function getTenantAssetPath(tenantId: string, assetName: string) {
  return `/tenants/${tenantId}/${assetName}`;
}

export const DefaultTenant: Tenant =
  process.env.REACT_APP_TENANT === TENANT_IDS.ATTRACTION
    ? {
        tenantName: "Attraction",
        logo: {
          logo: getTenantAssetPath(TENANT_IDS.ATTRACTION, "logo.svg"),
          logomark: getTenantAssetPath(TENANT_IDS.ATTRACTION, "logomark.svg"),
        },
        tenantId: TENANT_IDS.ATTRACTION,
      }
    : {
        tenantName: "Jameo",
        logo: {
          logo: getTenantAssetPath(TENANT_IDS.JAMEO, "logo.svg"),
          logomark: getTenantAssetPath(TENANT_IDS.JAMEO, "logomark.svg"),
        },
        tenantId: TENANT_IDS.JAMEO,
      };

export const TenantContext = createContext<{
  tenant: Tenant;
  isTenantLoading: boolean;
}>({
  tenant: DefaultTenant,
  isTenantLoading: false,
});
